<router-outlet></router-outlet>
<app-cookie-consent-banner></app-cookie-consent-banner>
<!--div *ngIf="showChatBot">
  <button *ngIf="!isChatbotOpen" class="chatbot-button" (click)="openChatbot()"><img class="chatbot-icon"
      src="../assets/img/gif/softy.gif"></button>
  <button *ngIf="isChatbotOpen" class="chatbot-button" (click)="openChatbot()"><img class="chatbot-icon"
      src="../assets/img/gif/writing.gif"></button>
  <app-chatbot *ngIf="isChatbotOpen" (close)="closeChatbot()"></app-chatbot>
</div-->
